import styled from "styled-components";

export const PreviewStyles = styled.div`
  margin-top: 85px;
  width: 100%;
  max-width: 1140px;
  margin: 0 auto 80px;
  padding: 0 10px;
`;

export const HeaderStyles = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 85px 0 47px 0;
  font-size: 28px;
  font-weight: bold;
  .company-name {
    color: var(--glz-color-success);
  }
  @media (max-width: 900px) {
    font-size: 22px;
  }
`;

export const VerificationCompanyStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 90px;
  .title {
    line-height: 44px;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    padding-top: 0;
  }
  .list {
    list-style-type: none;
    font-size: 16px;
    padding-top: 12px;
    @media (max-width: 900px) {
      font-size: 12px;
    }
  }
  .list-column {
    list-style-type: none;
    font-size: 16px;
    padding: 12px 0 12px 18px;
    font-weight: 600;
    @media (max-width: 900px) {
      font-size: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .ui-items {
    display: flex;
    padding: 42px 0px 0 0px;
    @media (max-width: 900px) {
      justify-content: center;
    }
    .list-items {
      width: 100%;
      text-align: center;
      padding-right: 15px;
    }
  }
  .list-items-clolumn {
    display: flex;
    @media (max-width: 900px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .verification-button {
    margin-top: 36px;
  }

  .verification-company {
    max-width: 510px;
    font-size: 20px;
    @media (max-width: 900px) {
      text-align: center;
    }
  }
  .sub-title-description {
    line-height: 32px;
    font-size: 20px;
    @media (max-width: 900px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    padding-bottom: 24px;
    @media (max-width: 900px) {
      font-size: 22px;
    }
  }
  .money {
    color: var(--glz-color-success);
    display: inline;
  }
`;

export const VerifationLogoStyle = styled.img`
  width: 501px;
  height: 532px;
  @media (max-width: 900px) {
    display: none;
  }
`;

export const FuelSpecialConditionLogoStyle = styled.img`
  width: 591px;
  height: 412px;
  @media (max-width: 900px) {
    display: none;
  }
`;

export const Title = styled.div`
  color: var(--glz-color-neutral-tone-5);
  font-size: 20px;
  @media (max-width: 900px) {
    padding-top: 20px;
  }
`;
